import { initialize as _initialize, checkInitialized, Axios } from "@spica-devkit/internal_common";
import { Observable } from "rxjs";
let authorization;
let service;
const identitySegment = "passport/identity";
class _Challenge {
    constructor(res, answerResponseMapper = r => r) {
        this.res = res;
        this.answerResponseMapper = answerResponseMapper;
    }
    show() {
        return this.res.challenge;
    }
    answer(answer) {
        return service.post(this.res.answerUrl, { answer }).then(r => this.answerResponseMapper(r));
    }
}
export function initialize(options) {
    const { authorization: _authorization, service: _service } = _initialize(options);
    authorization = _authorization;
    service = _service;
    service.setWriteDefaults({
        headers: {
            "Content-Type": "application/json"
        }
    });
}
export function verifyToken(token, baseUrl) {
    const _baseUrl = baseUrl ? baseUrl : service ? service.baseUrl : undefined;
    if (!_baseUrl) {
        throw new Error("You should pass the base url of the server or call the initialize method.");
    }
    const req = new Axios({ baseURL: _baseUrl });
    return req.get(`${identitySegment}/verify`, { headers: { Authorization: token } });
}
export async function login(identifier, password, tokenLifeSpan) {
    checkInitialized(authorization);
    return service
        .post("/passport/identify", {
        identifier,
        password,
        expires: tokenLifeSpan
    })
        .then(r => {
        if (isTokenScheme(r)) {
            return r.token;
        }
        const challenge = new _Challenge(r, r => r.token);
        return challenge;
    });
}
// we don't want to export this function because it's for internal usages
function isTokenScheme(response) {
    return typeof response.token == "string";
}
export function isChallenge(tokenOrChallenge) {
    return typeof tokenOrChallenge.show == "function" && typeof tokenOrChallenge.answer == "function";
}
export async function loginWithStrategy(id) {
    checkInitialized(authorization);
    const { url, state } = await service.get(`/passport/strategy/${id}/url`);
    const token = new Observable(observer => {
        service
            .post("/passport/identify", {
            state
        })
            .then(r => {
            if (isTokenScheme(r)) {
                observer.next(r.token);
            }
            else {
                const challenge = new _Challenge(r, r => r.token);
                observer.next(challenge);
            }
            observer.complete();
        })
            .catch(e => observer.error(e));
    });
    return {
        url,
        token
    };
}
export var authfactor;
(function (authfactor) {
    function list() {
        return service.get("passport/identity/factors");
    }
    authfactor.list = list;
    async function register(identityId, factor) {
        const response = await service.post(`passport/identity/${identityId}/start-factor-verification`, factor);
        const challenge = new _Challenge(response, response => response.message);
        return challenge;
    }
    authfactor.register = register;
    function unregister(identityId) {
        return service.delete(`passport/identity/${identityId}/factors`);
    }
    authfactor.unregister = unregister;
})(authfactor || (authfactor = {}));
export function getStrategies() {
    return service.get("/passport/strategies");
}
export function get(id) {
    checkInitialized(authorization);
    return service.get(`${identitySegment}/${id}`);
}
export function getAll(queryParams = {}) {
    checkInitialized(authorization);
    return service.get(identitySegment, {
        params: queryParams
    });
}
export async function insert(identity) {
    checkInitialized(authorization);
    const insertedIdentity = await service.post(identitySegment, identity);
    return policy.attach(insertedIdentity._id, identity.policies).then(policies => {
        insertedIdentity.policies = policies;
        return insertedIdentity;
    });
}
export async function update(id, identity) {
    checkInitialized(authorization);
    const existingIdentity = await service.get(`${identitySegment}/${id}`);
    await policy.detach(id, existingIdentity.policies || []);
    const updatedIdentity = await service.put(`${identitySegment}/${id}`, identity);
    return policy.attach(id, identity.policies || []).then(policies => {
        updatedIdentity.policies = policies;
        return updatedIdentity;
    });
}
export function remove(id) {
    checkInitialized(authorization);
    return service.delete(`${identitySegment}/${id}`);
}
// policy attach detach
export var policy;
(function (policy) {
    function attach(identityId, policyIds = []) {
        checkInitialized(authorization);
        const promises = [];
        const attachedPolicies = new Set();
        for (const policyId of policyIds) {
            const promise = service
                .put(`${identitySegment}/${identityId}/policy/${policyId}`, {})
                .then(() => attachedPolicies.add(policyId))
                .catch(e => {
                console.error(`Failed to attach policy with id ${policyId}: `, e);
                return e;
            });
            promises.push(promise);
        }
        return Promise.all(promises).then(() => Array.from(attachedPolicies));
    }
    policy.attach = attach;
    function detach(identityId, policyIds = []) {
        checkInitialized(authorization);
        const promises = [];
        const detachedPolicies = new Set();
        for (const policyId of policyIds) {
            const promise = service
                .delete(`${identitySegment}/${identityId}/policy/${policyId}`)
                .then(() => detachedPolicies.add(policyId))
                .catch(e => {
                console.error(`Failed to detach policy with id ${policyId}: `, e);
                return e;
            });
            promises.push(promise);
        }
        return Promise.all(promises).then(() => Array.from(detachedPolicies));
    }
    policy.detach = detach;
})(policy || (policy = {}));
//# sourceMappingURL=identity.js.map